// import Login from '../component/authen/login2/login'
import Playground from '../component/web/playground/playground'
// import ResearchPaperManage from '../component/web/researchPaperManage/researchPaperManage'
import ManageProjectManager from '../component/web/manageProject/manageProject'

import DescriptionIcon from '@material-ui/icons/Description'
import SportsEsportsIcon from '@material-ui/icons/SportsEsports'
// import EditManager from '../component/web/manageProject/edit/editManager'
// import CreateManager from '../component/web/manageProject/create/createManager'
import RichTextBox from '../component/web/playground/RichText/showRichTextbox'
import Report from '../component/um/dashboard/report/Report'
import Reviewer from '../pages/Reviewer'
import Expired from '../pages/Expired'
import Closed from '../pages/Closed'
import ClosedDue from '../pages/ClosedDue'
import CertificateSummary from '../pages/CertificateSummary'
import RiskProjectSummary from '../pages/RiskProjectSummary'
import DeletedProject from '../pages/DeletedProject'

import Login from '../pages/Login'

import RegisterExternal from '../pages/RegisterExternal'
import ExternalResearcher from '../pages/ExternalResearcher'
import ApproveExResearcher from '../pages/ApproveExResearcher'

import ForgotPassword from '../pages/ForgotPassword'
import Officer from '../pages/Officer'
import UsergroupAdd from './../pages/UsergroupAdd'
import UsergroupEdit from './../pages/UsergroupEdit'

import PreferenceProfile from '../pages/Preference'
import Activate from '../pages/Activate'
import ActivateForgot from '../pages/ActivateForgotPassword'
import Dashboard from '../pages/Dashboard'
import AllExport from '../pages/TestExport'

import FirstTime from '../pages/FirstTime'
import Hold from '../pages/Hold'
import ConnectLine from '../pages/ConnectLine'

import SettingCertificate from '../pages/SettingCertificate'
import SettingFaculty from '../pages/SettingFaculty'
import SettingFacultyAdd from './../pages/SettingFacultyAdd'
import SettingRECAdd from '../pages/SettingRECAdd'
import SettingRECEdit from '../pages/settingRECEdit'
import SettingDocument from '../pages/SettingDocument'
import SettingREC from '../pages/SettingREC'
import SettingDocumentAdd from '../pages/SettingDocumentAdd'
import SettingDocumentEdit from '../pages/SettingDocumentEdit'
import SettingFacultyEdit from '../pages/SettingFacultyEdit'
import SettingConsideration from '../pages/SettingConsideration'
import SettingConsiderationEdit from '../pages/SettingConsiderationEdit'
import Landing from '../pages/Landing'
import ProjectManager from '../component/web/project/projectManager'
import constWebFunction from '../constants/webFunction'
import ExternalProject from '../pages/ExternalProject'
import DocumentVerifyHistory from '../pages/DocumentVerifyHistory'
import AddExternalProject from '../pages/AddExternalProject'
import PendingHistory from '../component/web/manageProject/search/PendingHistory'
import ConsiderTypeHistory from '../component/web/shareUI/defineType/ConsiderTypeHistory'
import ManageExpertises from '../pages/ManageExpertises'
import ExpertiseForm from '../component/web/expertises/ExpertiseForm'
import ManageCommittees from '../pages/committees/ManageCommittees'
import CommitteeEdit from '../pages/committees/CommitteeEdit'
import ManageCheckList from '../pages/checklist/ManageCheckList'
import AddEditCheckList from '../pages/checklist/AddEditCheckList'
import ManageResearcher from '../pages/researcher/ManageResearcher'
import ManageResearcherEdit from '../pages/researcher/ManageResearcherEdit'
import UserHistoryUpload from '../component/um/officer/UserHistoryUpload'
import ResearcherDocuments from '../pages/ResearcherDocuments'
import SettingHoliday from '../pages/SettingHoliday'
import SettingSystem from '../pages/SettingSystem'
import SubmissionApproval from '../pages/SubmissionApproval'
import CreateAgenda from '../pages/CreateAgenda'
import EditAgenda from '../pages/EditAgenda'
import SettingAgendas from '../pages/SettingAgendas'
import ExportAgenda from '../pages/ExportAgenda'

export enum RoutePath {
    root = '/',
    login = '/login',
    playground = '/playground',
    researchManage = '/research-manage',
    manageProject = '/manage-project',
    // manageProjectEdit = '/manage-project/:id/edit', //'/manage-project/:id/edit',
    manageProjectEdit = '/manage-project/:projectID/:submittedID/edit',
    documentVerifyHistory = '/document-verify-history/:projectData',
    manageProjectCreateRequest = '/manage-project/create',
    // manageProjectView = '/manage-project/:id', //'/manage-project/:id/view',
    activate = '/authen/activate',
    activateForgotPassword = '/forgot-password/activate',
    manageExternalProject = '/manage-external-project',
    manageExternalProjectFormAdd = '/manage-external-project/add',
    manageExternalProjectFormEdit = `/manage-external-project/:projectID/edit`,
    projectPendingHistory = '/project-pending-history/:projectData',
    considerTypeHistory = '/consider-type-history/:projectData',

    register = '/external/register',
    externalResearcher = '/external-researcher/register',
    approveExResearcher = '/external-researcher/:id/approve',
    forgotPassword = '/forgot-password',
    profileForm = '/profile-form',

    officer = '/officer',
    preference = '/preference',
    userGroupAdd = '/officer/add',
    userGroupEdit = '/officer/:id/edit',
    userGroupHistoryUpload = '/officer/fileHistory/:userID',

    reviewer = '/reviewer/',
    firstTime = '/firsttime/',
    hold = '/hold/',
    expired = '/expired/',

    closed = '/closed',
    closedDue = '/closedDue',
    certificateSummary = '/certificateSummary',
    riskProjectSummary = '/riskProjectSummary',
    deletedProject = '/deletedProject',

    Report = '/report',

    dashboard = '/dashboard',
    testExport = '/test-export',

    settingCertificate = '/settingCertificate',
    settingREC = '/SettingREC',
    settingFaculty = '/setting-faculty',
    settingFacultyAdd = '/setting-faculty/add',
    settingFacultyEdit = '/setting-faculty/:id/edit',
    settingConsideration = '/setting-consideration',
    settingConsiderationEdit = '/setting-consideration/:id/edit',
    settingRECAdd = '/settingREC/Add',
    settingRECEdit = '/settingREC/:id/edit',
    settingDocument = '/settingDocument',
    settingDocumentAdd = '/settingDocument/add',
    settingDocumentEdit = '/settingDocument/:id/edit',

    manageExpertises = '/manage-expertises',
    expertisesAdd = '/expertises/add',
    expertisesEdit = '/expertises/:id/edit',

    manageCommittees = '/manage-committees',
    committeeEdit = '/manage-committees/:id/edit',

    manageCheckList = '/manage-checklist',
    addEditCheckList = '/manage-checklist/:topicID',

    manageResearcher = '/manage-researcher',
    manageResearcherEdit = '/manage-researcher/:id/edit',

    landing = '/landing',
    researcherDocument = '/researcherDocument',
    settingHoliday = '/settingHoliday',
    settingSystem = '/settingSystem',
    submissionApproval = '/submissionApproval',
    createAgenda = '/settingAgendas/create',
    editAgenda = '/settingAgendas/:id/edit',
    settingAgendas = '/settingAgendas',
    exportAgenda = '/settingAgendas/:id/export',
}

export type RoutesType = {
    functionID?: number //id matching with database
    path: string
    component: any
    exact: boolean
    isDisplayMenu: boolean
    menuName: string
    menuLabelKey: string
    menuID: string
    menuIcon: JSX.Element
    subRoute?: Array<RoutesType>
    allowAccessGroupID?: number[]
}
export const lstPublicRoutes: Array<RoutesType> = [
    {
        path: RoutePath.root,
        component: Login,
        exact: true,
        isDisplayMenu: false,
        menuName: 'root',
        menuLabelKey: '',
        menuID: 'public_root',
        menuIcon: <></>,
    },
    {
        path: RoutePath.activate,
        component: Activate,
        exact: true,
        isDisplayMenu: false,
        menuName: 'activate',
        menuLabelKey: '',
        menuID: 'public_root',
        menuIcon: <></>,
    },
    {
        path: RoutePath.activateForgotPassword,
        component: ActivateForgot,
        exact: true,
        isDisplayMenu: false,
        menuName: 'activate',
        menuLabelKey: '',
        menuID: 'public_root',
        menuIcon: <></>,
    },
    {
        path: RoutePath.login,
        component: Login,
        exact: true,
        isDisplayMenu: false,
        menuName: 'Login',
        menuLabelKey: '',
        menuID: 'public_login',
        menuIcon: <></>,
    },
    {
        path: RoutePath.forgotPassword,
        component: ForgotPassword,
        exact: true,
        isDisplayMenu: false,
        menuName: 'Forgot Password',
        menuLabelKey: '',
        menuID: 'public_login',
        menuIcon: <></>,
    },
    {
        path: RoutePath.register,
        component: RegisterExternal,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'rich-text',
        subRoute: [],
    },
    {
        path: RoutePath.register,
        component: RegisterExternal,
        exact: true,
        isDisplayMenu: false,
        menuName: 'register',
        menuLabelKey: '',
        menuID: 'public_login',
        menuIcon: <></>,
    },
    {
        path: '/connect/line',
        component: ConnectLine,
        exact: true,
        isDisplayMenu: false,
        menuName: 'connectLine',
        menuLabelKey: '',
        menuID: 'connect_line',
        menuIcon: <></>,
    },
    {
        path: RoutePath.landing,
        component: Landing,
        exact: true,
        isDisplayMenu: false,
        menuName: 'landingPage',
        menuLabelKey: '',
        menuID: 'landing_page',
        menuIcon: <></>,
    },

    {
        functionID: constWebFunction.manageProject, // หรือ constWebFunction.submissionApproval (ถ้ามี)
        path: RoutePath.submissionApproval,
        component: SubmissionApproval,
        exact: true,
        isDisplayMenu: false,
        menuName: 'Submission Approval',
        menuLabelKey: '',
        menuID: 'submission-approval',
        menuIcon: <></>,
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.exportAgenda,
        component: ExportAgenda,
        exact: true,
        isDisplayMenu: false,
        menuName: 'ExportAgenda',
        menuLabelKey: '',
        menuID: 'export-agenda',
        menuIcon: <></>,
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
]

export const lstPrivateRoutes: Array<RoutesType> = [
    {
        path: RoutePath.playground,
        component: Playground,
        exact: false,
        isDisplayMenu: false,
        menuName: 'Play Ground',
        menuLabelKey: 'playground',
        menuID: 'private_playground',
        menuIcon: <SportsEsportsIcon />,
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.dashboard,
        component: Dashboard,
        exact: true,
        isDisplayMenu: true,
        menuName: 'แดชบอร์ด',
        menuLabelKey: 'LABEL.DASHBOARD',
        menuIcon: <DescriptionIcon />,
        menuID: 'dashboard',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.firstTime,
        component: FirstTime,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuID: 'firsttime',
        menuIcon: <></>,
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.reviewer,
        component: Reviewer,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'reviewer',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.hold,
        component: Hold,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuID: 'hold',
        menuIcon: <></>,
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.expired,
        component: Expired,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'expired',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.closed,
        component: Closed,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'closed',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.closedDue,
        component: ClosedDue,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'closed_due',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.certificateSummary,
        component: CertificateSummary,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'certificate_summary',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.riskProjectSummary,
        component: RiskProjectSummary,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'risk_project_summary',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.deletedProject,
        component: DeletedProject,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'deleted_project',
        subRoute: [],
    },
    {
        functionID: constWebFunction.dashboard,
        path: RoutePath.Report,
        component: Report,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuIcon: <DescriptionIcon />,
        menuID: 'report',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.manageProject,
        component: ManageProjectManager,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการโครงการ',
        menuLabelKey: 'LABEL.PROJECT_MANAGEMENT',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_ResearchPaperManage',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.manageProjectEdit,
        component: ProjectManager,
        // component: EditManager,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'private_manage_project_edit',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.manageProjectCreateRequest,
        component: ProjectManager,
        // component: CreateManager,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'private_manage_project_create',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageDocument,
        path: RoutePath.researcherDocument,
        component: ResearcherDocuments,
        exact: true,
        isDisplayMenu: true,
        menuName: 'เอกสารผู้วิจัย',
        menuLabelKey: '',
        menuID: 'researcher-document',
        menuIcon: <DescriptionIcon />,
    },
    /** Start History */
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.documentVerifyHistory,
        component: DocumentVerifyHistory,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'private_document_verify_history',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.projectPendingHistory,
        component: PendingHistory,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'private_project_pending_history',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageProject,
        path: RoutePath.considerTypeHistory,
        component: ConsiderTypeHistory,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'private_consider_type_history',
        subRoute: [],
    },
    /** End History */
    /** Start Manage External Projects */
    {
        functionID: constWebFunction.manageExternalProject,
        path: RoutePath.manageExternalProject,
        component: ExternalProject,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการโครงการนอกระบบก่อนปี 2565',
        menuLabelKey: 'LABEL.EXTERNAL_PROJECT_MANAGEMENT',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_ExternalProjectManage',
        subRoute: [],
        allowAccessGroupID: [2, 3, 6, 7],
    },
    {
        functionID: constWebFunction.manageExternalProject,
        path: RoutePath.manageExternalProjectFormAdd,
        component: AddExternalProject,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <></>,
        menuID: 'form_add_ExternalProjectManage',
    },
    {
        functionID: constWebFunction.manageExternalProject,
        path: RoutePath.manageExternalProjectFormEdit,
        component: AddExternalProject,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <></>,
        menuID: 'form_edit_ExternalProjectManage',
    },
    /** End Manage External Projects */
    /** Start Expertises LUT */
    {
        functionID: constWebFunction.manageExpertises,
        path: RoutePath.manageExpertises,
        component: ManageExpertises,
        exact: true,
        isDisplayMenu: true,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_manage_expertises',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageExpertises,
        path: RoutePath.expertisesAdd,
        component: ExpertiseForm,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_expertises_add',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageExpertises,
        path: RoutePath.expertisesEdit,
        component: ExpertiseForm,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_expertises_edit',
        subRoute: [],
    },
    /** End Expertises LUT */
    /** Start Manage Researcher */
    {
        functionID: constWebFunction.manageResearcher,
        path: RoutePath.manageResearcher,
        component: ManageResearcher,
        exact: true,
        isDisplayMenu: true,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_manage_researcher',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageResearcher,
        path: RoutePath.manageResearcherEdit,
        component: ManageResearcherEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_manage_researcher_edit',
        subRoute: [],
    },
    /** End Manage Researcher */
    {
        functionID: constWebFunction.manageExternalResearcher,
        path: RoutePath.externalResearcher,
        component: ExternalResearcher,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการข้อมูลผู้วิจัยภายนอก',
        menuLabelKey: 'UM.EXTERNAL-RESEARCHER.MENU',
        menuIcon: <DescriptionIcon />,
        menuID: 'external-researcher',
        subRoute: [],
        allowAccessGroupID: [2],
    },
    {
        functionID: constWebFunction.manageExternalResearcher,
        path: RoutePath.approveExResearcher,
        component: ApproveExResearcher,
        exact: true,
        isDisplayMenu: false,
        menuName: 'พิจารณาข้อมูลนักวิจัยภายนอก',
        menuLabelKey: 'พิจารณาข้อมูลนักวิจัยภายนอก',
        menuIcon: <DescriptionIcon />,
        menuID: 'external-researcher-approve',
        subRoute: [],
    },
    /** Start Manage Committees */
    {
        functionID: constWebFunction.manageCommittees,
        path: RoutePath.manageCommittees,
        component: ManageCommittees,
        exact: true,
        isDisplayMenu: true,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_manage_committees',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageCommittees,
        path: RoutePath.committeeEdit,
        component: CommitteeEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_committee_edit',
        subRoute: [],
    },
    /** End Manage Committees */
    {
        functionID: constWebFunction.manageUser,
        path: RoutePath.officer,
        component: Officer,
        exact: true,
        isDisplayMenu: true,
        menuName: 'รายชื่อผู้ใช้งานระบบ',
        menuLabelKey: 'รายชื่อผู้ใช้งานระบบ',
        menuIcon: <DescriptionIcon />,
        menuID: 'officer',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageUser,
        path: RoutePath.userGroupEdit,
        component: UsergroupEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: 'แก้ไขข้อมูล user',
        menuLabelKey: 'แก้ไขข้อมูล user',
        menuIcon: <DescriptionIcon />,
        menuID: 'officer-edit',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageUser,
        path: RoutePath.userGroupAdd,
        component: UsergroupAdd,
        exact: true,
        isDisplayMenu: false,
        menuName: 'เพิ่มข้อมูล user',
        menuLabelKey: 'เพิ่มข้อมูล user',
        menuIcon: <DescriptionIcon />,
        menuID: 'officer-add',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageUser,
        path: RoutePath.userGroupHistoryUpload,
        component: UserHistoryUpload,
        exact: true,
        isDisplayMenu: false,
        menuName: 'ประวัติการ Upload',
        menuLabelKey: 'ประวัติการ Upload',
        menuIcon: <DescriptionIcon />,
        menuID: 'officer-fileHistory',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageFaculty,
        path: RoutePath.settingFaculty,
        component: SettingFaculty,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการคณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ',
        menuLabelKey: 'จัดการคณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ',
        menuIcon: <DescriptionIcon />,
        menuID: 'settingFaculty',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageFaculty,
        path: RoutePath.settingFacultyAdd,
        component: SettingFacultyAdd,
        exact: true,
        isDisplayMenu: false,
        menuName: 'เพิ่มข้อมูลคณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ',
        menuLabelKey: 'เพิ่มข้อมูล Setting คณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ',
        menuIcon: <DescriptionIcon />,
        menuID: 'SettingFacultyAdd',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageFaculty,
        path: RoutePath.settingFacultyEdit,
        component: SettingFacultyEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: 'แก้ไขข้อมูล Setting คณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ',
        menuLabelKey: 'แก้ไขข้อมูล Setting คณะ / สำนักงาน / วิทยาลัยที่เกี่ยวข้องกับโครงการ',
        menuIcon: <DescriptionIcon />,
        menuID: 'SettingFacultyEdit',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageREC,
        path: RoutePath.settingREC,
        component: SettingREC,
        exact: true,
        isDisplayMenu: true,
        menuName: 'รายชื่อกลุ่มสหสถาบัน',
        menuLabelKey: 'LABEL.SETTINGREC',
        menuIcon: <DescriptionIcon />,
        menuID: 'settingREC',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageREC,
        path: RoutePath.settingRECAdd,
        component: SettingRECAdd,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuID: 'settingRECAdd',
        menuIcon: <></>,
    },
    {
        functionID: constWebFunction.manageREC,
        path: RoutePath.settingRECEdit,
        component: SettingRECEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuID: 'settingRECEdit',
        menuIcon: <></>,
    },
    {
        functionID: constWebFunction.manageProjectSubmittedType,
        path: RoutePath.settingDocument,
        component: SettingDocument,
        exact: true,
        isDisplayMenu: true,
        menuName: 'SettingDocument',
        menuLabelKey: 'LABEL.SETTINGDOCUMENT',
        menuIcon: <DescriptionIcon />,
        menuID: 'SettingDocument',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageProjectSubmittedType,
        path: RoutePath.settingDocumentAdd,
        component: SettingDocumentAdd,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuID: 'settingDocumentAdd',
        menuIcon: <></>,
    },
    {
        functionID: constWebFunction.manageProjectSubmittedType,
        path: RoutePath.settingDocumentEdit,
        component: SettingDocumentEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: '',
        menuLabelKey: '',
        menuID: 'settingDocumentEdit',
        menuIcon: <></>,
    },
    {
        functionID: constWebFunction.manageEditResultOfConsideration,
        path: RoutePath.settingConsideration,
        component: SettingConsideration,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการแก้ไขชื่อผลการพิจารณา ',
        menuLabelKey: 'จัดการแก้ไขชื่อผลการพิจารณา ',
        menuIcon: <DescriptionIcon />,
        menuID: 'setting',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageEditResultOfConsideration,
        path: RoutePath.settingConsiderationEdit,
        component: SettingConsiderationEdit,
        exact: true,
        isDisplayMenu: false,
        menuName: 'แก้ไขข้อมูล Setting แก้ไขชื่อผลการพิจารณา ',
        menuLabelKey: 'แก้ไขข้อมูล Setting แก้ไขชื่อผลการพิจารณา ',
        menuIcon: <DescriptionIcon />,
        menuID: 'SettingConsiderationEdit',
        subRoute: [],
    },
    /** Start Manage Checklist */
    {
        functionID: constWebFunction.manageCheckList,
        path: RoutePath.manageCheckList,
        component: ManageCheckList,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการรายการแบบฟอร์มความเห็นพิจารณาโครงการ',
        menuLabelKey: 'LABEL.MANAGE_CHECKLIST',
        menuIcon: <DescriptionIcon />,
        menuID: 'private_manage_checklist',
        subRoute: [],
        allowAccessGroupID: [2],
    },
    {
        functionID: constWebFunction.manageCheckList,
        path: RoutePath.addEditCheckList,
        component: AddEditCheckList,
        exact: true,
        isDisplayMenu: false,
        menuIcon: <></>,
        menuID: 'private_manage_checklist_form',
        menuName: '-',
        menuLabelKey: '-',
    },
    /** End Manage Checklist */
    {
        functionID: constWebFunction.manageCertificateAndStamp,
        path: RoutePath.settingCertificate,
        component: SettingCertificate,
        exact: true,
        isDisplayMenu: true,
        menuName: 'เปลี่ยนข้อความในใบรับรองและตราสำนักงาน',
        menuLabelKey: 'LABEL.SETTINGCERTIFICATE',
        menuIcon: <DescriptionIcon />,
        menuID: 'settingCertificate',
        subRoute: [],
        allowAccessGroupID: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        functionID: constWebFunction.manageHoliday,
        path: RoutePath.settingHoliday,
        component: SettingHoliday,
        exact: true,
        isDisplayMenu: true,
        menuName: 'จัดการวันหยุดนักขัตฤกษ์',
        menuLabelKey: 'จัดการวันหยุดนักขัตฤกษ์',
        menuIcon: <DescriptionIcon />,
        menuID: 'settingHoliday',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageSystem,
        path: RoutePath.settingSystem,
        component: SettingSystem,
        exact: true,
        isDisplayMenu: true,
        menuName: 'ตั้งค่าระบบ',
        menuLabelKey: 'ตั้งค่าระบบ',
        menuIcon: <DescriptionIcon />,
        menuID: 'settingSystem',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageAgendas,
        path: RoutePath.createAgenda,
        component: CreateAgenda,
        exact: true,
        isDisplayMenu: false,
        menuName: 'สร้างวาระการประชุม',
        menuLabelKey: 'สร้างวาระการประชุม',
        menuIcon: <></>,
        menuID: 'createAgenda',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageAgendas,
        path: RoutePath.editAgenda,
        component: EditAgenda,
        exact: true,
        isDisplayMenu: false,
        menuName: 'แก้ไขวาระการประชุม',
        menuLabelKey: 'แก้ไขวาระการประชุม',
        menuIcon: <></>,
        menuID: 'editAgenda',
        subRoute: [],
    },
    {
        functionID: constWebFunction.manageAgendas,
        path: RoutePath.settingAgendas,
        component: SettingAgendas,
        exact: true,
        isDisplayMenu: true,
        menuName: 'ตั้งค่าวาระการประชุม',
        menuLabelKey: 'ตั้งค่าวาระการประชุม',
        menuIcon: <DescriptionIcon />,
        menuID: 'settingAgenda',
        subRoute: [],
    },
    {
        path: '/richtext',
        component: RichTextBox,
        exact: true,
        isDisplayMenu: false,
        menuName: '-',
        menuLabelKey: '-',
        menuIcon: <div></div>,
        menuID: 'rich-text',
        subRoute: [],
    },
    {
        path: RoutePath.testExport,
        component: AllExport,
        exact: true,
        isDisplayMenu: false,
        menuName: 'test',
        menuLabelKey: 'test',
        menuIcon: <DescriptionIcon />,
        menuID: 'test',
        subRoute: [],
    },
    {
        functionID: constWebFunction.preference,
        path: RoutePath.preference,
        component: PreferenceProfile,
        exact: true,
        isDisplayMenu: false,
        menuName: 'Preference Profile',
        menuLabelKey: '',
        menuID: 'public_login',
        menuIcon: <></>,
    },
]
